/* global BigInt */
import React, { useState, useEffect } from 'react';
import { ethers } from 'ethers';
import { 
  Button, TextField, Container, Paper, CircularProgress, 
  Alert, Typography, Box, Checkbox, FormControlLabel,
  Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Switch, Slider, Chip, Collapse, Dialog,
  DialogTitle, DialogContent, DialogContentText, DialogActions,
  Select, MenuItem, InputLabel, FormControl, Grid, LinearProgress,
  IconButton
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import DeleteIcon from '@mui/icons-material/Delete';

// ==================== 合约配置 ====================
const PANCAKE_ROUTER_V2 = '0x10ED43C718714eb63d5aA57B78B54704E256024E';
const PANCAKE_FACTORY_V2 = '0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73';
const WBNB_ADDRESS = '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c';

// ==================== 默认代币配置 ====================
const DEFAULT_TOKENS = {
  BNB: {
    address: WBNB_ADDRESS,
    decimals: 18,
    symbol: 'BNB'
  },
  USDT: {
    address: '0x55d398326f99059fF775485246999027B3197955',
    decimals: 18,
    symbol: 'USDT'
  },
  BUSD: {
    address: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56',
    decimals: 18,
    symbol: 'BUSD'
  }
};

// ==================== 安全配置 ====================
const ADMIN_CONFIG = {
  adminPasswords: ['bioach', 'cz76538', 'btygh23', 'hj67tyu', 'opti784', 'df73jkl', 'wekdjt', '123'], // 支持多个管理员密码
  adminAddress: '0x539c7b6b3e439b1016e476af9eaa1f92f9bf7d8f' // 替换为实际管理员地址
};

// ==================== RPC配置 ====================
const RPC_URLS = [
  { name: 'Binance', url: 'https://bsc-dataseed.binance.org/' },
  { name: 'Defibit', url: 'https://bsc-dataseed1.defibit.io/' },
  { name: 'Ninicoin', url: 'https://bsc-dataseed1.ninicoin.io/' },
  { name: 'BSC', url: 'https://bscrpc.com' },
  { name: '1', url: 'https://rpc.ankr.com/bsc' },
  { name: '2', url: 'https://binance.nodereal.io' },
  { name: '3', url: 'https://rpc-bsc.bnb48.club' }
];

// ==================== ABIs ====================
const ERC20_ABI = [
  "function name() view returns (string)",
  "function symbol() view returns (string)",
  "function decimals() view returns (uint8)",
  "function balanceOf(address) view returns (uint256)",
  "function approve(address spender, uint256 amount) returns (bool)",
  "function allowance(address owner, address spender) view returns (uint256)"
];

const PANCAKE_ROUTER_ABI = [{
	"inputs": [{
		"internalType": "address",
		"name": "_factory",
		"type": "address"
	}, {
		"internalType": "address",
		"name": "_WETH",
		"type": "address"
	}],
	"stateMutability": "nonpayable",
	"type": "constructor"
}, {
	"inputs": [],
	"name": "WETH",
	"outputs": [{
		"internalType": "address",
		"name": "",
		"type": "address"
	}],
	"stateMutability": "view",
	"type": "function"
}, {
	"inputs": [{
		"internalType": "address",
		"name": "tokenA",
		"type": "address"
	}, {
		"internalType": "address",
		"name": "tokenB",
		"type": "address"
	}, {
		"internalType": "uint256",
		"name": "amountADesired",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountBDesired",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountAMin",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountBMin",
		"type": "uint256"
	}, {
		"internalType": "address",
		"name": "to",
		"type": "address"
	}, {
		"internalType": "uint256",
		"name": "deadline",
		"type": "uint256"
	}],
	"name": "addLiquidity",
	"outputs": [{
		"internalType": "uint256",
		"name": "amountA",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountB",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "liquidity",
		"type": "uint256"
	}],
	"stateMutability": "nonpayable",
	"type": "function"
}, {
	"inputs": [{
		"internalType": "address",
		"name": "token",
		"type": "address"
	}, {
		"internalType": "uint256",
		"name": "amountTokenDesired",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountTokenMin",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountETHMin",
		"type": "uint256"
	}, {
		"internalType": "address",
		"name": "to",
		"type": "address"
	}, {
		"internalType": "uint256",
		"name": "deadline",
		"type": "uint256"
	}],
	"name": "addLiquidityETH",
	"outputs": [{
		"internalType": "uint256",
		"name": "amountToken",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountETH",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "liquidity",
		"type": "uint256"
	}],
	"stateMutability": "payable",
	"type": "function"
}, {
	"inputs": [],
	"name": "factory",
	"outputs": [{
		"internalType": "address",
		"name": "",
		"type": "address"
	}],
	"stateMutability": "view",
	"type": "function"
}, {
	"inputs": [{
		"internalType": "uint256",
		"name": "amountOut",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "reserveIn",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "reserveOut",
		"type": "uint256"
	}],
	"name": "getAmountIn",
	"outputs": [{
		"internalType": "uint256",
		"name": "amountIn",
		"type": "uint256"
	}],
	"stateMutability": "pure",
	"type": "function"
}, {
	"inputs": [{
		"internalType": "uint256",
		"name": "amountIn",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "reserveIn",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "reserveOut",
		"type": "uint256"
	}],
	"name": "getAmountOut",
	"outputs": [{
		"internalType": "uint256",
		"name": "amountOut",
		"type": "uint256"
	}],
	"stateMutability": "pure",
	"type": "function"
}, {
	"inputs": [{
		"internalType": "uint256",
		"name": "amountOut",
		"type": "uint256"
	}, {
		"internalType": "address[]",
		"name": "path",
		"type": "address[]"
	}],
	"name": "getAmountsIn",
	"outputs": [{
		"internalType": "uint256[]",
		"name": "amounts",
		"type": "uint256[]"
	}],
	"stateMutability": "view",
	"type": "function"
}, {
	"inputs": [{
		"internalType": "uint256",
		"name": "amountIn",
		"type": "uint256"
	}, {
		"internalType": "address[]",
		"name": "path",
		"type": "address[]"
	}],
	"name": "getAmountsOut",
	"outputs": [{
		"internalType": "uint256[]",
		"name": "amounts",
		"type": "uint256[]"
	}],
	"stateMutability": "view",
	"type": "function"
}, {
	"inputs": [{
		"internalType": "uint256",
		"name": "amountA",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "reserveA",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "reserveB",
		"type": "uint256"
	}],
	"name": "quote",
	"outputs": [{
		"internalType": "uint256",
		"name": "amountB",
		"type": "uint256"
	}],
	"stateMutability": "pure",
	"type": "function"
}, {
	"inputs": [{
		"internalType": "address",
		"name": "tokenA",
		"type": "address"
	}, {
		"internalType": "address",
		"name": "tokenB",
		"type": "address"
	}, {
		"internalType": "uint256",
		"name": "liquidity",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountAMin",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountBMin",
		"type": "uint256"
	}, {
		"internalType": "address",
		"name": "to",
		"type": "address"
	}, {
		"internalType": "uint256",
		"name": "deadline",
		"type": "uint256"
	}],
	"name": "removeLiquidity",
	"outputs": [{
		"internalType": "uint256",
		"name": "amountA",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountB",
		"type": "uint256"
	}],
	"stateMutability": "nonpayable",
	"type": "function"
}, {
	"inputs": [{
		"internalType": "address",
		"name": "token",
		"type": "address"
	}, {
		"internalType": "uint256",
		"name": "liquidity",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountTokenMin",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountETHMin",
		"type": "uint256"
	}, {
		"internalType": "address",
		"name": "to",
		"type": "address"
	}, {
		"internalType": "uint256",
		"name": "deadline",
		"type": "uint256"
	}],
	"name": "removeLiquidityETH",
	"outputs": [{
		"internalType": "uint256",
		"name": "amountToken",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountETH",
		"type": "uint256"
	}],
	"stateMutability": "nonpayable",
	"type": "function"
}, {
	"inputs": [{
		"internalType": "address",
		"name": "token",
		"type": "address"
	}, {
		"internalType": "uint256",
		"name": "liquidity",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountTokenMin",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountETHMin",
		"type": "uint256"
	}, {
		"internalType": "address",
		"name": "to",
		"type": "address"
	}, {
		"internalType": "uint256",
		"name": "deadline",
		"type": "uint256"
	}, {
		"internalType": "bool",
		"name": "approveMax",
		"type": "bool"
	}, {
		"internalType": "uint8",
		"name": "v",
		"type": "uint8"
	}, {
		"internalType": "bytes32",
		"name": "r",
		"type": "bytes32"
	}, {
		"internalType": "bytes32",
		"name": "s",
		"type": "bytes32"
	}],
	"name": "removeLiquidityETHWithPermit",
	"outputs": [{
		"internalType": "uint256",
		"name": "amountToken",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountETH",
		"type": "uint256"
	}],
	"stateMutability": "nonpayable",
	"type": "function"
}, {
	"inputs": [{
		"internalType": "address",
		"name": "token",
		"type": "address"
	}, {
		"internalType": "uint256",
		"name": "liquidity",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountTokenMin",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountETHMin",
		"type": "uint256"
	}, {
		"internalType": "address",
		"name": "to",
		"type": "address"
	}, {
		"internalType": "uint256",
		"name": "deadline",
		"type": "uint256"
	}, {
		"internalType": "bool",
		"name": "approveMax",
		"type": "bool"
	}, {
		"internalType": "uint8",
		"name": "v",
		"type": "uint8"
	}, {
		"internalType": "bytes32",
		"name": "r",
		"type": "bytes32"
	}, {
		"internalType": "bytes32",
		"name": "s",
		"type": "bytes32"
	}],
	"name": "removeLiquidityETHWithPermitSupportingFeeOnTransferTokens",
	"outputs": [{
		"internalType": "uint256",
		"name": "amountETH",
		"type": "uint256"
	}],
	"stateMutability": "nonpayable",
	"type": "function"
}, {
	"inputs": [{
		"internalType": "address",
		"name": "tokenA",
		"type": "address"
	}, {
		"internalType": "address",
		"name": "tokenB",
		"type": "address"
	}, {
		"internalType": "uint256",
		"name": "liquidity",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountAMin",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountBMin",
		"type": "uint256"
	}, {
		"internalType": "address",
		"name": "to",
		"type": "address"
	}, {
		"internalType": "uint256",
		"name": "deadline",
		"type": "uint256"
	}, {
		"internalType": "bool",
		"name": "approveMax",
		"type": "bool"
	}, {
		"internalType": "uint8",
		"name": "v",
		"type": "uint8"
	}, {
		"internalType": "bytes32",
		"name": "r",
		"type": "bytes32"
	}, {
		"internalType": "bytes32",
		"name": "s",
		"type": "bytes32"
	}],
	"name": "removeLiquidityWithPermit",
	"outputs": [{
		"internalType": "uint256",
		"name": "amountA",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountB",
		"type": "uint256"
	}],
	"stateMutability": "nonpayable",
	"type": "function"
}, {
	"inputs": [{
		"internalType": "uint256",
		"name": "amountOut",
		"type": "uint256"
	}, {
		"internalType": "address[]",
		"name": "path",
		"type": "address[]"
	}, {
		"internalType": "address",
		"name": "to",
		"type": "address"
	}, {
		"internalType": "uint256",
		"name": "deadline",
		"type": "uint256"
	}],
	"name": "swapETHForExactTokens",
	"outputs": [{
		"internalType": "uint256[]",
		"name": "amounts",
		"type": "uint256[]"
	}],
	"stateMutability": "payable",
	"type": "function"
}, {
	"inputs": [{
		"internalType": "uint256",
		"name": "amountOutMin",
		"type": "uint256"
	}, {
		"internalType": "address[]",
		"name": "path",
		"type": "address[]"
	}, {
		"internalType": "address",
		"name": "to",
		"type": "address"
	}, {
		"internalType": "uint256",
		"name": "deadline",
		"type": "uint256"
	}],
	"name": "swapExactETHForTokens",
	"outputs": [{
		"internalType": "uint256[]",
		"name": "amounts",
		"type": "uint256[]"
	}],
	"stateMutability": "payable",
	"type": "function"
}, {
	"inputs": [{
		"internalType": "uint256",
		"name": "amountOutMin",
		"type": "uint256"
	}, {
		"internalType": "address[]",
		"name": "path",
		"type": "address[]"
	}, {
		"internalType": "address",
		"name": "to",
		"type": "address"
	}, {
		"internalType": "uint256",
		"name": "deadline",
		"type": "uint256"
	}],
	"name": "swapExactETHForTokensSupportingFeeOnTransferTokens",
	"outputs": [],
	"stateMutability": "payable",
	"type": "function"
}, {
	"inputs": [{
		"internalType": "uint256",
		"name": "amountIn",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountOutMin",
		"type": "uint256"
	}, {
		"internalType": "address[]",
		"name": "path",
		"type": "address[]"
	}, {
		"internalType": "address",
		"name": "to",
		"type": "address"
	}, {
		"internalType": "uint256",
		"name": "deadline",
		"type": "uint256"
	}],
	"name": "swapExactTokensForETH",
	"outputs": [{
		"internalType": "uint256[]",
		"name": "amounts",
		"type": "uint256[]"
	}],
	"stateMutability": "nonpayable",
	"type": "function"
}, {
	"inputs": [{
		"internalType": "uint256",
		"name": "amountIn",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountOutMin",
		"type": "uint256"
	}, {
		"internalType": "address[]",
		"name": "path",
		"type": "address[]"
	}, {
		"internalType": "address",
		"name": "to",
		"type": "address"
	}, {
		"internalType": "uint256",
		"name": "deadline",
		"type": "uint256"
	}],
	"name": "swapExactTokensForETHSupportingFeeOnTransferTokens",
	"outputs": [],
	"stateMutability": "nonpayable",
	"type": "function"
}, {
	"inputs": [{
		"internalType": "uint256",
		"name": "amountIn",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountOutMin",
		"type": "uint256"
	}, {
		"internalType": "address[]",
		"name": "path",
		"type": "address[]"
	}, {
		"internalType": "address",
		"name": "to",
		"type": "address"
	}, {
		"internalType": "uint256",
		"name": "deadline",
		"type": "uint256"
	}],
	"name": "swapExactTokensForTokens",
	"outputs": [{
		"internalType": "uint256[]",
		"name": "amounts",
		"type": "uint256[]"
	}],
	"stateMutability": "nonpayable",
	"type": "function"
}, {
	"inputs": [{
		"internalType": "uint256",
		"name": "amountIn",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountOutMin",
		"type": "uint256"
	}, {
		"internalType": "address[]",
		"name": "path",
		"type": "address[]"
	}, {
		"internalType": "address",
		"name": "to",
		"type": "address"
	}, {
		"internalType": "uint256",
		"name": "deadline",
		"type": "uint256"
	}],
	"name": "swapExactTokensForTokensSupportingFeeOnTransferTokens",
	"outputs": [],
	"stateMutability": "nonpayable",
	"type": "function"
}, {
	"inputs": [{
		"internalType": "uint256",
		"name": "amountOut",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountInMax",
		"type": "uint256"
	}, {
		"internalType": "address[]",
		"name": "path",
		"type": "address[]"
	}, {
		"internalType": "address",
		"name": "to",
		"type": "address"
	}, {
		"internalType": "uint256",
		"name": "deadline",
		"type": "uint256"
	}],
	"name": "swapTokensForExactETH",
	"outputs": [{
		"internalType": "uint256[]",
		"name": "amounts",
		"type": "uint256[]"
	}],
	"stateMutability": "nonpayable",
	"type": "function"
}, {
	"inputs": [{
		"internalType": "uint256",
		"name": "amountOut",
		"type": "uint256"
	}, {
		"internalType": "uint256",
		"name": "amountInMax",
		"type": "uint256"
	}, {
		"internalType": "address[]",
		"name": "path",
		"type": "address[]"
	}, {
		"internalType": "address",
		"name": "to",
		"type": "address"
	}, {
		"internalType": "uint256",
		"name": "deadline",
		"type": "uint256"
	}],
	"name": "swapTokensForExactTokens",
	"outputs": [{
		"internalType": "uint256[]",
		"name": "amounts",
		"type": "uint256[]"
	}],
	"stateMutability": "nonpayable",
	"type": "function"
}, {
	"stateMutability": "payable",
	"type": "receive"
}];

const PANCAKE_FACTORY_ABI = [
  "function getPair(address tokenA, address tokenB) external view returns (address pair)"
];

// ==================== 工具函数 ====================
function formatBigInt(value, decimals = 18) {
  if (!value || value.toString() === '0') return '0';
  try {
    return ethers.formatUnits(value, decimals);
  } catch (err) {
    console.error("格式化BigInt失败:", err);
    return '0';
  }
}

function getRandomAmount(min, max, decimals = 6) {
  const random = Math.random() * (parseFloat(max) - parseFloat(min)) + parseFloat(min);
  return parseFloat(random.toFixed(decimals));
}

// 修改formatPrice函数
function formatPrice(price) {
  if (!price) return '0';
  if (parseFloat(price) === 0) return '0';

  try {
    const str = price.toString();
    
    // 处理科学计数法
    if (str.includes('e')) {
      const [base, exponent] = str.split('e');
      const exp = parseInt(exponent);
      const sign = base.startsWith('-') ? '-' : '';
      const baseStr = base.replace('.', '').replace('-', '');
      
      if (exp < 0) {
        // 处理小数
        const absExp = Math.abs(exp);
        
        // 找到基数中的小数点位置
        const dotIndex = base.indexOf('.');
        const baseDecimals = dotIndex === -1 ? 0 : base.length - dotIndex - 1;
        
        // 计算需要补充的0的数量
        const zerosNeeded = absExp - baseDecimals;
        
        // 构建结果
        if (zerosNeeded > 0) {
          return `${sign}0.${'0'.repeat(zerosNeeded)}${baseStr}`;
        } else {
          // 如果基数已经有足够的小数位，直接格式化
          const num = parseFloat(base) * Math.pow(10, exp);
          return num.toString();
        }
      } else {
        // 处理大数
        return (parseFloat(base) * Math.pow(10, exp)).toString();
      }
    }
    
    // 对于普通数字，直接返回原始字符串以保持格式
    return str;
    
  } catch (err) {
    console.error('格式化价格失败:', err);
    return price.toString();
  }
}

async function getBNBBalance(provider, address) {
  try {
    const balance = await provider.getBalance(address);
    return ethers.formatEther(balance);
  } catch (err) {
    console.error("获取BNB余额失败:", err);
    return "0";
  }
}

async function transferBNBFromOtherWallet(provider, fromWallet, toAddress, requiredAmount) {
  try {
    const tx = await fromWallet.sendTransaction({
      to: toAddress,
      value: ethers.parseEther(requiredAmount.toString()),
      gasLimit: 21000
    });
    
    await tx.wait();
    console.log(`从钱包 ${fromWallet.address} 转入 ${requiredAmount} BNB 到 ${toAddress}`);
    return true;
  } catch (err) {
    console.error("BNB转账失败:", err);
    return false;
  }
}

// 添加交易对配置
const TRADING_PAIRS = [
  { symbol: 'BNB', address: DEFAULT_TOKENS.BNB.address, decimals: 18 },
  { symbol: 'USDT', address: DEFAULT_TOKENS.USDT.address, decimals: 18 },
  { symbol: 'BUSD', address: DEFAULT_TOKENS.BUSD.address, decimals: 18 },
  { symbol: 'FIST', address: '0xc9882def23bc42d53895b8361d0b1edc7570bc6a', decimals: 18 },
  { symbol: 'OSK', address: '0x8b5d3a1d2eebbe91c6f5781c37c1c0b9b7a9e8d7', decimals: 18 }
];

function PancakeV2BatchSwap() {
  // ==================== 状态管理 ====================
  const [provider, setProvider] = useState(null);
  const [wallets, setWallets] = useState([]);
  const [selectedWallets, setSelectedWallets] = useState([]);
  const [adminMode, setAdminMode] = useState(false);
  const [password, setPassword] = useState('');
  const [connectedAddress, setConnectedAddress] = useState('');
  const [currentRpcUrl, setCurrentRpcUrl] = useState(RPC_URLS[0].url);
  const [tokenAddress, setTokenAddress] = useState('');
  const [tokenInfo, setTokenInfo] = useState({ name: '', symbol: '', decimals: 18 });
  const [privateKeys, setPrivateKeys] = useState('');
  const [showSecurityWarning, setShowSecurityWarning] = useState(false);
  const [totalBalances, setTotalBalances] = useState({ bnb: '0', token: '0' });
  const [priceInfo, setPriceInfo] = useState({
    price: '0',
    usdtPrice: '0',
    liquidity: '0',
    pairToken: '',
    status: '',
    bnbUsdtRate: '0'
  });
  const [buyAmount, setBuyAmount] = useState('0.01');
  const [buyAmountRange, setBuyAmountRange] = useState({ min: '0.01', max: '0.02' });
  const [useRandomBuyAmount, setUseRandomBuyAmount] = useState(false);
  const [buySequentialMode, setBuySequentialMode] = useState(false);
  const [buyDelayBetweenTx, setBuyDelayBetweenTx] = useState(5);
  const [buySlippage, setBuySlippage] = useState('1.0');
  const [sellAmount, setSellAmount] = useState('100');
  const [sellAmountRange, setSellAmountRange] = useState({ min: '0.01', max: '0.02' });
  const [useRandomSellAmount, setUseRandomSellAmount] = useState(false);
  const [sellSequentialMode, setSellSequentialMode] = useState(false);
  const [sellDelayBetweenTx, setSellDelayBetweenTx] = useState(5);
  const [sellSlippage, setSellSlippage] = useState('1.0');
  const [showVolumeSettings, setShowVolumeSettings] = useState(false);
  const [buyPercentage, setBuyPercentage] = useState(50);
  const [sellPercentage, setSellPercentage] = useState(50);
  const [isVolumeTrading, setIsVolumeTrading] = useState(false);
  const [volumeRounds, setVolumeRounds] = useState(1);
  const [currentRound, setCurrentRound] = useState(0);
  const [volumeTradeStatus, setVolumeTradeStatus] = useState({
    isRunning: false,
    currentRound: 0,
    totalRounds: 1,
    currentAction: '',
    processedCount: 0,
    totalCount: 0
  });
  const [loading, setLoading] = useState(false);
  const [activeTx, setActiveTx] = useState(null);
  const [txHistory, setTxHistory] = useState([]);
  const [error, setError] = useState(null);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const [volumeBuyAmount, setVolumeBuyAmount] = useState('0.01');
  const [volumeSellAmount, setVolumeSellAmount] = useState('0.01');
  const [volumeBuyAmountRange, setVolumeBuyAmountRange] = useState({ min: '0.01', max: '0.02' });
  const [volumeSellAmountRange, setVolumeSellAmountRange] = useState({ min: '0.01', max: '0.02' });
  const [useVolumeRandomBuyAmount, setUseVolumeRandomBuyAmount] = useState(false);
  const [useVolumeRandomSellAmount, setUseVolumeRandomSellAmount] = useState(false);
  const [volumeBuySlippage, setVolumeBuySlippage] = useState('1.0');
  const [volumeSellSlippage, setVolumeSellSlippage] = useState('1.0');
  const [volumeBuySequentialMode, setVolumeBuySequentialMode] = useState(false);
  const [volumeSellSequentialMode, setVolumeSellSequentialMode] = useState(false);
  const [volumeBuyDelayBetweenTx, setVolumeBuyDelayBetweenTx] = useState(5);
  const [volumeSellDelayBetweenTx, setVolumeSellDelayBetweenTx] = useState(5);
  const [transactionHistory, setTransactionHistory] = useState([]);
  const [currentActiveTx, setCurrentActiveTx] = useState(null);
  const [showVolumeTradeResults, setShowVolumeTradeResults] = useState(false);
  const [transactionStatus, setTransactionStatus] = useState({
    isProcessing: false,
    currentOperation: '',
    progress: 0,
    total: 0,
    successCount: 0,
    failCount: 0,
    lastError: null
  });
  const [selectedPair, setSelectedPair] = useState(TRADING_PAIRS[0]);
  const [rpcProvider, setRpcProvider] = useState(null);
  
  // 添加缺失的状态变量
  const [volumeTradingActive, setVolumeTradingActive] = useState(false);
  const [volumeSequentialMode, setVolumeSequentialMode] = useState(false);
  const [volumeDelayBetweenTx, setVolumeDelayBetweenTx] = useState(0);
  const [volumeSlippage, setVolumeSlippage] = useState(5);
  const [volumeAmount, setVolumeAmount] = useState(0.01);
  const [volumeAmountRange, setVolumeAmountRange] = useState(0.005);
  const [useRandomVolumeAmount, setUseRandomVolumeAmount] = useState(false);
  const [volumeInterval, setVolumeInterval] = useState(60);

  // 添加独立的loading状态
  const [connectLoading, setConnectLoading] = useState(false);
  const [importLoading, setImportLoading] = useState(false);
  const [updateBalanceLoading, setUpdateBalanceLoading] = useState(false);
  const [fetchTokenLoading, setFetchTokenLoading] = useState(false);
  const [batchBuyLoading, setBatchBuyLoading] = useState(false);
  const [batchSellLoading, setBatchSellLoading] = useState(false);
  const [volumeTradingLoading, setVolumeTradingLoading] = useState(false);

  // 在组件内添加RPC选择状态
  const [selectedRpc, setSelectedRpc] = useState(RPC_URLS[0]);

  // 添加GAS相关状态
  const [customGasPrice, setCustomGasPrice] = useState('');
  const [useCustomGas, setUseCustomGas] = useState(false);

  // ==================== 核心函数 ====================
  const checkAdminStatus = (address) => {
    if (!address) {
      setAdminMode(false);
      return;
    }
    const isAdminWallet = address.toLowerCase() === ADMIN_CONFIG.adminAddress.toLowerCase();
    setAdminMode(isAdminWallet);
  };

  // 修改connectWallet函数
  const connectWallet = async () => {
    if (window.ethereum) {
      try {
        setConnectLoading(true);
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        setConnectedAddress(accounts[0]);
        checkAdminStatus(accounts[0]);
      } catch (err) {
        setError("用户拒绝连接钱包");
      } finally {
        setConnectLoading(false);
      }
    } else {
      setError("未检测到 MetaMask 或其他钱包扩展");
    }
  };

  const handleAdminLogin = () => {
    const isPasswordValid = ADMIN_CONFIG.adminPasswords.includes(password);
    const isAdminWallet = connectedAddress?.toLowerCase() === ADMIN_CONFIG.adminAddress.toLowerCase();
    
    if (isPasswordValid || isAdminWallet) {
      setAdminMode(true);
      setError(null);
    } else {
      setError('认证失败：密码错误或非管理员钱包');
    }
  };

  // 添加provider初始化
  useEffect(() => {
    const initProvider = async () => {
      try {
        if (window.ethereum) {
          const provider = new ethers.BrowserProvider(window.ethereum);
          setProvider(provider);
        } else {
          setError("未检测到 MetaMask 或其他钱包扩展");
        }
      } catch (err) {
        console.error("初始化provider失败:", err);
        setError("初始化provider失败");
      }
    };

    initProvider();
  }, []);

  // 初始化RPC Provider
  useEffect(() => {
    const initRpcProvider = async () => {
      try {
        const provider = new ethers.JsonRpcProvider(currentRpcUrl);
        setRpcProvider(provider);
      } catch (err) {
        console.error("初始化RPC Provider失败:", err);
        setError("初始化RPC Provider失败");
      }
    };

    initRpcProvider();
  }, [currentRpcUrl]);

  // 修改fetchTokenInfo函数
  const fetchTokenInfo = async () => {
    if (!rpcProvider) {
      setError("RPC Provider未初始化");
      return;
    }

    if (!tokenAddress) {
      setError("请输入代币地址");
      return;
    }

    if (!ethers.isAddress(tokenAddress)) {
      setError("无效的代币地址");
      return;
    }
    
    try {
      setFetchTokenLoading(true);
      setError(null);
      
      const tokenContract = new ethers.Contract(tokenAddress, ERC20_ABI, rpcProvider);
      const [name, symbol, decimals] = await Promise.all([
        tokenContract.name(),
        tokenContract.symbol(),
        tokenContract.decimals()
      ]);
      
      setTokenInfo({ name, symbol, decimals: Number(decimals) });
      
      // 获取价格信息
      await fetchPriceAndLiquidity();
      
      if (wallets.length > 0) {
        await fetchWalletsBalances(wallets);
      }

      console.log("代币信息获取成功:", { name, symbol, decimals });
    } catch (err) {
      console.error("获取代币信息失败:", err);
      setError(`获取代币信息失败: ${err.message}`);
      setTokenInfo({ name: '', symbol: '', decimals: 18 });
    } finally {
      setFetchTokenLoading(false);
    }
  };

  // 添加计算总余额的函数
  const calculateTotalBalances = (walletsList) => {
    const totals = walletsList.reduce((acc, wallet) => {
      const tokenUsdtValue = parseFloat(wallet.tokenBalance) * parseFloat(priceInfo.usdtPrice);
      return {
        bnb: (parseFloat(acc.bnb) + parseFloat(wallet.bnbBalance || '0')).toFixed(6),
        token: (parseFloat(acc.token) + parseFloat(wallet.tokenBalance || '0')).toFixed(6),
        tokenUsdtValue: (parseFloat(acc.tokenUsdtValue || '0') + tokenUsdtValue).toFixed(2)
      };
    }, { bnb: '0', token: '0', tokenUsdtValue: '0' });
    setTotalBalances(totals);
  };

  // 修改fetchWalletsBalances函数
  const fetchWalletsBalances = async (walletsToUpdate) => {
    if (!provider || !tokenAddress) return;
    
    try {
      const tokenContract = new ethers.Contract(tokenAddress, ERC20_ABI, provider);
      
      const updatedWallets = await Promise.all(walletsToUpdate.map(async wallet => {
        const [bnbBalance, tokenBalance] = await Promise.all([
          provider.getBalance(wallet.address),
          tokenContract.balanceOf(wallet.address)
        ]);
        
        return {
          ...wallet,
          bnbBalance: formatBigInt(bnbBalance),
          tokenBalance: formatBigInt(tokenBalance, tokenInfo.decimals)
        };
      }));
      
      setWallets(updatedWallets);
      calculateTotalBalances(updatedWallets);
    } catch (err) {
      console.error("获取钱包余额失败:", err);
      setError(`获取余额失败: ${err.message}`);
    }
  };

  // 获取BNB-USDT价格
  const getBnbUsdtPrice = async (provider) => {
    try {
      const router = new ethers.Contract(PANCAKE_ROUTER_V2, PANCAKE_ROUTER_ABI, provider);
      const path = [DEFAULT_TOKENS.BNB.address, DEFAULT_TOKENS.USDT.address];
      const amounts = await router.getAmountsOut(ethers.parseEther('1'), path);
      return ethers.formatUnits(amounts[1], DEFAULT_TOKENS.USDT.decimals);
    } catch (err) {
      console.error("获取BNB-USDT价格失败:", err);
      return '0';
    }
  };

  // 修改fetchPriceAndLiquidity函数
  const fetchPriceAndLiquidity = async () => {
    if (!rpcProvider || !tokenAddress) return null;
  
    try {
      setLoading(true);
      
      // 获取BNB/USDT价格
      const bnbUsdtPrice = await getBnbUsdtPrice(rpcProvider);
      
      // 检查代币是否有选择的交易对
      const factory = new ethers.Contract(PANCAKE_FACTORY_V2, PANCAKE_FACTORY_ABI, rpcProvider);
      const pairAddress = await factory.getPair(tokenAddress, selectedPair.address);
      
      if (pairAddress === ethers.ZeroAddress) {
        setPriceInfo({
          price: '0',
          usdtPrice: '0',
          liquidity: '0',
          pairToken: selectedPair.symbol,
          status: 'No Liquidity',
          bnbUsdtRate: bnbUsdtPrice,
          source: 'PancakeSwap',
          timestamp: new Date().toLocaleString()
        });
        return;
      }
      
      // 获取代币价格
      const router = new ethers.Contract(PANCAKE_ROUTER_V2, PANCAKE_ROUTER_ABI, rpcProvider);
      const path = [tokenAddress, selectedPair.address];
      const amounts = await router.getAmountsOut(ethers.parseUnits('1', tokenInfo.decimals), path);
      
      const tokenPrice = ethers.formatUnits(amounts[1], selectedPair.decimals);
      
      // 计算USDT价格
      let usdtPrice = '0';
      if (selectedPair.symbol === 'BNB') {
        usdtPrice = (parseFloat(tokenPrice) * parseFloat(bnbUsdtPrice)).toString();
      } else if (selectedPair.symbol === 'USDT') {
        usdtPrice = tokenPrice;
      } else if (selectedPair.symbol === 'BUSD') {
        const busdUsdtPath = [DEFAULT_TOKENS.BUSD.address, DEFAULT_TOKENS.USDT.address];
        const busdUsdtAmounts = await router.getAmountsOut(ethers.parseUnits('1', DEFAULT_TOKENS.BUSD.decimals), busdUsdtPath);
        const busdUsdtPrice = ethers.formatUnits(busdUsdtAmounts[1], DEFAULT_TOKENS.USDT.decimals);
        usdtPrice = (parseFloat(tokenPrice) * parseFloat(busdUsdtPrice)).toString();
      }
      
      // 获取流动性信息
      const pairContract = new ethers.Contract(pairAddress, [
        "function getReserves() external view returns (uint112 reserve0, uint112 reserve1, uint32 blockTimestampLast)",
        "function token0() external view returns (address)"
      ], rpcProvider);
      
      const reserves = await pairContract.getReserves();
      const token0 = await pairContract.token0();
      let liquidity;
      
      // 确定哪个是交易对代币的储备
      if (token0.toLowerCase() === tokenAddress.toLowerCase()) {
        // 如果代币是token0，那么reserve1就是交易对的流动性
        liquidity = ethers.formatUnits(reserves.reserve1, selectedPair.decimals);
      } else {
        // 如果代币是token1，那么reserve0就是交易对的流动性
        liquidity = ethers.formatUnits(reserves.reserve0, selectedPair.decimals);
      }
      
      const newPriceInfo = {
        price: formatPrice(tokenPrice),
        usdtPrice: formatPrice(usdtPrice),
        liquidity: liquidity,
        pairToken: selectedPair.symbol,
        status: 'Active',
        bnbUsdtRate: bnbUsdtPrice,
        source: 'PancakeSwap',
        timestamp: new Date().toLocaleString()
      };
      
      setPriceInfo(newPriceInfo);
      setError(null);
      return newPriceInfo;
    } catch (err) {
      console.error("获取价格和流动性失败:", err);
      setPriceInfo(prev => ({
        ...prev,
        status: 'Error',
        timestamp: new Date().toLocaleString()
      }));
      setError(`获取价格失败: ${err.message}`);
      return null;
    } finally {
      setLoading(false);
    }
  };

  // 添加钱包管理工具函数
  const validateWallet = (wallet) => {
    if (!wallet.address || !wallet.privateKey) {
      return false;
    }
    try {
      // 验证地址格式
      if (!ethers.isAddress(wallet.address)) {
        return false;
      }
      // 验证私钥格式
      if (!ethers.isHexString(wallet.privateKey, 32)) {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  };

  // 优化导入私钥功能
  const importPrivateKeys = async () => {
    if (!privateKeys.trim()) {
      setError('请输入有效的私钥');
      return;
    }

    try {
      setImportLoading(true);
      setError(null);
      
      const keys = privateKeys.split('\n').map(key => key.trim()).filter(key => key);
      if (keys.length === 0) {
        throw new Error('请输入有效的私钥');
      }
      
      const newWallets = [];
      const invalidKeys = [];
      
      for (const key of keys) {
        try {
          const wallet = new ethers.Wallet(key, provider);
          const walletData = {
            address: wallet.address,
            privateKey: wallet.privateKey,
            isSelected: false,
            bnbBalance: '0',
            tokenBalance: '0'
          };
          
          if (!wallets.some(w => w.address.toLowerCase() === wallet.address.toLowerCase())) {
            newWallets.push(walletData);
          }
        } catch (err) {
          invalidKeys.push(key);
        }
      }
      
      if (newWallets.length === 0 && invalidKeys.length > 0) {
        throw new Error('没有有效的私钥');
      }
      
      // 更新钱包列表
      const updatedWallets = [...wallets, ...newWallets];
      setWallets(updatedWallets);
      calculateTotalBalances(updatedWallets);
      
      // 清空私钥输入框
      setPrivateKeys('');
      
      // 如果有代币地址，则获取新导入钱包的余额
      if (tokenAddress && provider) {
        await fetchWalletsBalances(newWallets);
      }
      
      if (invalidKeys.length > 0) {
        setError(`成功导入 ${newWallets.length} 个钱包，${invalidKeys.length} 个私钥无效`);
      } else {
        setError(`成功导入 ${newWallets.length} 个钱包`);
      }
    } catch (err) {
      handleError(err, '导入私钥');
    } finally {
      setImportLoading(false);
    }
  };

  // 优化余额检查功能
  const checkWalletBalances = async () => {
    try {
      setUpdateBalanceLoading(true);
      setError(null);
      
      // 只获取 BNB 余额
      const updatedWallets = await Promise.all(
        wallets.map(async (wallet) => {
          const bnbBalance = await rpcProvider.getBalance(wallet.address);
          
          return {
            ...wallet,
            bnbBalance: ethers.formatEther(bnbBalance),
            tokenBalance: tokenAddress ? wallet.tokenBalance : '0' // 如果没有代币地址,保持代币余额为0
          };
        })
      );
      
      setWallets(updatedWallets);
      calculateTotalBalances(updatedWallets);
      setError('余额更新完成');
    } catch (err) {
      console.error("更新余额失败:", err);
      setError(`更新余额失败: ${err.message}`);
    } finally {
      setUpdateBalanceLoading(false);
    }
  };

  // 优化自动重平衡功能
  const checkAndAutoRebalanceWallet = async (wallet, requiredAmount) => {
    try {
      const MIN_BNB_BALANCE = 0.005;
      const sufficientWallets = wallets.filter(w => 
        w.address !== wallet.address && 
        parseFloat(w.bnbBalance) > MIN_BNB_BALANCE * 2
      );
      
      if (sufficientWallets.length === 0) {
        throw new Error('没有余额足够的钱包可用于转账');
      }
      
      // 随机选择一个余额充足的钱包
      const donorWallet = sufficientWallets[Math.floor(Math.random() * sufficientWallets.length)];
      const transferAmount = requiredAmount + 0.001; // 额外添加0.001 BNB作为gas费
      
      const success = await transferBNBFromOtherWallet(
        provider,
        donorWallet,
        wallet.address,
        transferAmount
      );
      
      if (!success) {
        throw new Error('自动转入BNB失败');
      }
      
      return true;
    } catch (err) {
      handleError(err, `钱包 ${wallet.address} 自动重平衡`);
      return false;
    }
  };

  // 钱包间转账
  const transferBetweenWallets = async (fromWallet, toWallet, amount) => {
    if (!provider) return;
    try {
      setLoading(true);
      
      const formattedAmount = parseFloat(amount).toFixed(8);
      const walletSigner = new ethers.Wallet(fromWallet.privateKey, provider);
      const tx = await walletSigner.sendTransaction({
        to: toWallet.address,
        value: ethers.parseEther(formattedAmount)
      });
      
      await tx.wait();
      await fetchWalletsBalances(wallets);
      
      const txRecord = {
        wallet: fromWallet.address,
        type: '内部转账',
        spentAmount: formattedAmount,
        spentSymbol: 'BNB',
        receivedAmount: '',
        receivedSymbol: '',
        txHash: tx.hash,
        explorerUrl: `https://bscscan.com/tx/${tx.hash}`,
        timestamp: new Date().toLocaleString(),
        status: '已完成',
        note: `转账至 ${toWallet.address.slice(0, 6)}...${toWallet.address.slice(-4)}`
      };
      
      setTxHistory(prev => [txRecord, ...prev]);
      setError(null);
    } catch (err) {
      console.error("钱包间转账失败:", err);
      setError(`转账失败: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };
  
  // 检查并重新分配钱包余额
  const checkAndRebalanceWallets = async () => {
    if (wallets.length < 2 || !adminMode) {
      setError("需要至少两个钱包且需要管理员权限");
      return;
    }
    
    try {
      setLoading(true);
      
      const MIN_BNB_BALANCE = 0.005;
      const TARGET_BNB_BALANCE = 0.01;
      
      const sufficientWallets = wallets.filter(w => parseFloat(w.bnbBalance) > MIN_BNB_BALANCE * 2);
      const insufficientWallets = wallets.filter(w => parseFloat(w.bnbBalance) < MIN_BNB_BALANCE);
      
      if (insufficientWallets.length === 0) {
        setError("所有钱包余额均足够");
        setLoading(false);
        return;
      }
      
      if (sufficientWallets.length === 0) {
        setError("没有余额足够的钱包可用于转账");
        setLoading(false);
        return;
      }
      
      setPendingAction({
        type: 'rebalance',
        sufficientWallets,
        insufficientWallets,
        MIN_BNB_BALANCE,
        TARGET_BNB_BALANCE
      });
      setShowConfirmDialog(true);
      setLoading(false);
    } catch (err) {
      console.error("余额重新分配失败:", err);
      setError(`余额重新分配失败: ${err.message}`);
      setLoading(false);
    }
  };

  // 添加错误处理工具函数
  const handleError = (error, context) => {
    console.error(`[${context}] 错误:`, error);
    const errorMessage = error.message || '未知错误';
    setError(`${context}: ${errorMessage}`);
    setTxHistory(prev => [{
      wallet: activeTx?.wallet || '系统',
      type: context,
      error: errorMessage,
      timestamp: new Date().toLocaleString(),
      status: '失败'
    }, ...prev]);
  };

  // 添加日志记录函数
  const logTransaction = (txRecord) => {
    console.log(`[交易记录] ${txRecord.type}:`, {
      wallet: txRecord.wallet,
      amount: txRecord.spentAmount,
      symbol: txRecord.spentSymbol,
      status: txRecord.status,
      timestamp: txRecord.timestamp
    });
    setTxHistory(prev => [txRecord, ...prev]);
  };

  // 更新交易状态
  const updateTransactionStatus = (status) => {
    setTransactionStatus(prev => ({
      ...prev,
      ...status
    }));
  };

  // 重置交易状态
  const resetTransactionStatus = () => {
    setTransactionStatus({
      isProcessing: false,
      currentOperation: '',
      progress: 0,
      total: 0,
      successCount: 0,
      failCount: 0,
      lastError: null
    });
  };

  // 计算预期买入量
  const calculateExpectedBuyAmount = async (amountWei) => {
    try {
      const router = new ethers.Contract(PANCAKE_ROUTER_V2, PANCAKE_ROUTER_ABI, provider);
      const path = [DEFAULT_TOKENS.BNB.address, tokenAddress];
      const amounts = await router.getAmountsOut(amountWei, path);
      return amounts[1];
    } catch (err) {
      console.error("计算预期买入量失败:", err);
      // 如果计算失败，使用一个保守的估计值
      const slippageAmount = parseFloat(ethers.formatEther(amountWei)) * (1 - parseFloat(buySlippage) / 100);
      return ethers.parseUnits(slippageAmount.toString(), tokenInfo.decimals);
    }
  };

  // 计算预期卖出量
  const calculateExpectedSellAmount = async (amountWei) => {
    try {
      const router = new ethers.Contract(PANCAKE_ROUTER_V2, PANCAKE_ROUTER_ABI, provider);
      const path = [tokenAddress, DEFAULT_TOKENS.BNB.address];
      const amounts = await router.getAmountsOut(amountWei, path);
      return amounts[1];
    } catch (err) {
      console.error("计算预期卖出量失败:", err);
      // 如果计算失败，使用一个保守的估计值
      const slippageAmount = parseFloat(ethers.formatUnits(amountWei, tokenInfo.decimals)) * 
                            parseFloat(priceInfo.price) * 
                            (1 - parseFloat(sellSlippage) / 100);
      return ethers.parseEther(slippageAmount.toString());
    }
  };

  // 执行买入交易
  const processBuyTransaction = async (wallet, amount, currentIndex, totalCount, isVolumeTrade = false, customSlippage = null) => {
    try {
      updateTransactionStatus({
        isProcessing: true,
        currentOperation: '买入交易',
        progress: currentIndex,
        total: totalCount
      });
      
      const formattedAmount = parseFloat(amount).toFixed(18);
      const buyAmount = ethers.parseEther(formattedAmount);
      
      // 检查钱包余额
      const walletBalance = await provider.getBalance(wallet.address);
      const requiredAmount = buyAmount + (buyAmount * 10n / 100n);
      
      if (walletBalance < requiredAmount) {
        const transferSuccess = await transferBNBFromOtherWallet(provider, wallet, wallet.address, amount);
        if (!transferSuccess) {
          throw new Error(`钱包 ${wallet.address} 补充BNB失败`);
        }
      }
      
      // 获取预期收到的代币数量
      const expectedTokens = await calculateExpectedBuyAmount(buyAmount);
      const slippagePercent = parseFloat(customSlippage || (isVolumeTrade ? volumeBuySlippage : buySlippage));
      const minTokens = expectedTokens * BigInt(Math.floor((100 - slippagePercent) * 100)) / 10000n;
      
      // 记录交易前余额
      const tokenContract = new ethers.Contract(tokenAddress, ERC20_ABI, provider);
      const beforeTokenBalance = await tokenContract.balanceOf(wallet.address);
      
      // 创建签名者
      const walletSigner = new ethers.Wallet(wallet.privateKey, provider);
      const router = new ethers.Contract(PANCAKE_ROUTER_V2, PANCAKE_ROUTER_ABI, walletSigner);
      
      // 设置当前活动交易
      setActiveTx({
        wallet: wallet.address,
        type: '买入',
        amount: `${amount} BNB`,
        status: '准备交易',
        index: currentIndex,
        total: totalCount,
        isVolumeTrade
      });
      
      // 获取当前gas价格
      const gasPrice = await provider.getFeeData();
      
      // 准备交易参数
      const txParams = {
        value: buyAmount,
        gasLimit: 500000,
        gasPrice: useCustomGas && customGasPrice ? 
          ethers.parseUnits(customGasPrice, 'gwei') : 
          gasPrice.gasPrice * 3n
      };
      
      // 执行买入交易
      const tx = await router.swapExactETHForTokens(
        minTokens,
        [DEFAULT_TOKENS.BNB.address, tokenAddress],
        wallet.address,
        Math.floor(Date.now() / 1000) + 60 * 20, // 20分钟截止时间
        txParams
      );
      
      setActiveTx(prev => ({
        ...prev,
        status: '等待确认'
      }));
      
      const receipt = await tx.wait();
      
      if (receipt.status === 1) {
        updateTransactionStatus(prev => ({
          ...prev,
          successCount: prev.successCount + 1
        }));
        // 获取交易后的代币余额
        const afterTokenBalance = await tokenContract.balanceOf(wallet.address);
        const receivedTokens = ethers.formatUnits(
          BigInt(afterTokenBalance.toString()) - BigInt(beforeTokenBalance.toString()),
          tokenInfo.decimals
        );
        
        const txRecord = {
          wallet: wallet.address,
          type: isVolumeTrade ? '做市买入' : '买入',
          spentAmount: ethers.formatEther(buyAmount),
          spentSymbol: 'BNB',
          receivedAmount: receivedTokens,
          receivedSymbol: tokenInfo.symbol,
          txHash: tx.hash,
          explorerUrl: `https://bscscan.com/tx/${tx.hash}`,
          timestamp: new Date().toLocaleString(),
          status: '已完成',
          isVolumeTrade
        };
        
        logTransaction(txRecord);
        setTxHistory(prev => [txRecord, ...prev]);
        
        const updatedWallet = {
          ...wallet,
          bnbBalance: (parseFloat(wallet.bnbBalance) - amount).toFixed(6),
          tokenBalance: (parseFloat(wallet.tokenBalance) + parseFloat(receivedTokens)).toFixed(6)
        };
        
        setWallets(prev => prev.map(w => w.address === wallet.address ? updatedWallet : w));
        return true;
      } else {
        throw new Error('交易失败');
      }
    } catch (err) {
      // 交易失败时，重新获取价格并重试
      try {
        console.log(`钱包 ${wallet.address} 买入交易失败，正在重新获取价格并重试...`);
        await fetchPriceAndLiquidity(); // 重新获取价格信息
        
        // 重新计算交易参数
        const formattedAmount = parseFloat(amount).toFixed(18);
        const buyAmount = ethers.parseEther(formattedAmount);
        const expectedTokens = await calculateExpectedBuyAmount(buyAmount);
        const slippagePercent = parseFloat(customSlippage || (isVolumeTrade ? volumeBuySlippage : buySlippage));
        const minTokens = expectedTokens * BigInt(Math.floor((100 - slippagePercent) * 100)) / 10000n;
        
        // 获取新的gas价格
        const gasPrice = await provider.getFeeData();
        const txParams = {
          value: buyAmount,
          gasLimit: 500000,
          gasPrice: useCustomGas && customGasPrice ? 
            ethers.parseUnits(customGasPrice, 'gwei') : 
            gasPrice.gasPrice * 3n
        };
        
        // 重试交易
        const walletSigner = new ethers.Wallet(wallet.privateKey, provider);
        const router = new ethers.Contract(PANCAKE_ROUTER_V2, PANCAKE_ROUTER_ABI, walletSigner);
        
        setActiveTx(prev => ({
          ...prev,
          status: '重试交易'
        }));
        
        const retryTx = await router.swapExactETHForTokens(
          minTokens,
          [DEFAULT_TOKENS.BNB.address, tokenAddress],
          wallet.address,
          Math.floor(Date.now() / 1000) + 60 * 20,
          txParams
        );
        
        const retryReceipt = await retryTx.wait();
        
        if (retryReceipt.status === 1) {
          updateTransactionStatus(prev => ({
            ...prev,
            successCount: prev.successCount + 1
          }));
          
          // 重新获取交易前余额，因为之前的变量可能已经失效
          const tokenContract = new ethers.Contract(tokenAddress, ERC20_ABI, provider);
          const beforeTokenBalance = await tokenContract.balanceOf(wallet.address);
          const afterTokenBalance = await tokenContract.balanceOf(wallet.address);
          const receivedTokens = ethers.formatUnits(
            BigInt(afterTokenBalance.toString()) - BigInt(beforeTokenBalance.toString()),
            tokenInfo.decimals
          );
          
          const txRecord = {
            wallet: wallet.address,
            type: isVolumeTrade ? '做市买入(重试成功)' : '买入(重试成功)',
            spentAmount: ethers.formatEther(buyAmount),
            spentSymbol: 'BNB',
            receivedAmount: receivedTokens,
            receivedSymbol: tokenInfo.symbol,
            txHash: retryTx.hash,
            explorerUrl: `https://bscscan.com/tx/${retryTx.hash}`,
            timestamp: new Date().toLocaleString(),
            status: '已完成',
            isVolumeTrade
          };
          
          logTransaction(txRecord);
          setTxHistory(prev => [txRecord, ...prev]);
          
          const updatedWallet = {
            ...wallet,
            bnbBalance: (parseFloat(wallet.bnbBalance) - amount).toFixed(6),
            tokenBalance: (parseFloat(wallet.tokenBalance) + parseFloat(receivedTokens)).toFixed(6)
          };
          
          setWallets(prev => prev.map(w => w.address === wallet.address ? updatedWallet : w));
          return true;
        } else {
          throw new Error('重试交易失败');
        }
      } catch (retryErr) {
        updateTransactionStatus(prev => ({
          ...prev,
          failCount: prev.failCount + 1,
          lastError: retryErr.message
        }));
        handleError(retryErr, `钱包 ${wallet.address} 买入交易(重试失败)`);
        return false;
      }
    } finally {
      if (currentIndex === totalCount) {
        resetTransactionStatus();
      }
    }
  };

  // 执行卖出交易
  const processSellTransaction = async (wallet, sellPercentage, currentIndex, totalCount, isVolumeTrade = false, customSlippage = null) => {
    try {
      updateTransactionStatus({
        isProcessing: true,
        currentOperation: '卖出交易',
        progress: currentIndex,
        total: totalCount
      });
      
      // 获取钱包当前代币余额
      const tokenContract = new ethers.Contract(tokenAddress, ERC20_ABI, provider);
      const currentBalance = await tokenContract.balanceOf(wallet.address);
      
      if (currentBalance === 0n) {
        console.log(`钱包 ${wallet.address} 没有${tokenInfo.symbol}余额，跳过交易`);
        return false;
      }
      
      // 计算要卖出的代币数量
      const percentage = parseFloat(sellPercentage);
      if (isNaN(percentage) || percentage <= 0 || percentage > 100) {
        throw new Error('无效的卖出比例');
      }
      
      const amountWei = (currentBalance * BigInt(Math.floor(percentage * 100))) / 10000n;
      
      if (amountWei === 0n) {
        console.log(`钱包 ${wallet.address} 计算的卖出数量为0，跳过交易`);
        return false;
      }
      
      // 检查BNB余额是否足够支付交易费用
      const walletBnbBalance = await provider.getBalance(wallet.address);
      const MIN_REQUIRED_BNB = 0.001;
      
      if (parseFloat(ethers.formatEther(walletBnbBalance)) < MIN_REQUIRED_BNB) {
        const rebalanceSuccess = await checkAndAutoRebalanceWallet(wallet, MIN_REQUIRED_BNB);
        if (!rebalanceSuccess) {
          console.log(`无法为钱包 ${wallet.address} 自动转入BNB，卖出交易可能会失败`);
        }
      }
      
      let formattedAmount;
      
      if (isVolumeTrade) {
        formattedAmount = ethers.formatUnits(amountWei, tokenInfo.decimals);
      } else {
        formattedAmount = ethers.formatUnits(amountWei, tokenInfo.decimals);
      }
      
      // 创建签名者
      const walletSigner = new ethers.Wallet(wallet.privateKey, provider);
      const router = new ethers.Contract(PANCAKE_ROUTER_V2, PANCAKE_ROUTER_ABI, walletSigner);
      const signerTokenContract = new ethers.Contract(tokenAddress, ERC20_ABI, walletSigner);
      
      // 设置当前活动交易
      setActiveTx({
        wallet: wallet.address,
        type: '卖出',
        amount: `${formattedAmount} ${tokenInfo.symbol}`,
        status: '检查授权中',
        index: currentIndex,
        total: totalCount,
        isVolumeTrade
      });

      // 检查代币授权
      const currentAllowance = await signerTokenContract.allowance(wallet.address, PANCAKE_ROUTER_V2);
      
      if (currentAllowance < amountWei) {
        setActiveTx(prev => ({
          ...prev,
          status: '正在授权'
        }));
        
        try {
          const maxUint256 = ethers.MaxUint256;
          const gasPrice = await provider.getFeeData();
          
          const approveTx = await signerTokenContract.approve(PANCAKE_ROUTER_V2, maxUint256, {
            gasLimit: 100000,
            gasPrice: gasPrice.gasPrice
          });
          
          setActiveTx(prev => ({
            ...prev,
            status: '等待授权确认'
          }));
          
          const approveReceipt = await approveTx.wait();
          
          if (approveReceipt.status === 1) {
            await new Promise(resolve => setTimeout(resolve, 3000));
            const newAllowance = await signerTokenContract.allowance(wallet.address, PANCAKE_ROUTER_V2);
            
            if (newAllowance < amountWei) {
              throw new Error(`授权失败，新授权额度仍然不足`);
            }
          } else {
            throw new Error(`授权交易失败`);
          }
        } catch (approveErr) {
          throw new Error(`代币授权失败: ${approveErr.message}`);
        }
      }
      
      // 获取预期收到的资金和最小资金
      setActiveTx(prev => ({
        ...prev,
        status: '计算交易参数'
      }));
      
      let expectedFunds;
      try {
        expectedFunds = await calculateExpectedSellAmount(amountWei);
      } catch (err) {
        expectedFunds = amountWei * ethers.parseEther("1") / ethers.parseUnits("100000000", tokenInfo.decimals);
      }
      
      const slippagePercent = parseFloat(customSlippage || (isVolumeTrade ? volumeSellSlippage : sellSlippage));
      const minFundsWei = expectedFunds * BigInt(Math.floor((100 - slippagePercent) * 100)) / 10000n;
      const minFunds = minFundsWei > 0n ? minFundsWei : ethers.parseEther("0.0000001");
      
      // 记录交易前余额
      const beforeBnbBalance = await provider.getBalance(wallet.address);
      
      // 执行卖出交易
      setActiveTx(prev => ({
        ...prev,
        status: '执行卖出交易'
      }));
      
      // 获取并调整gas价格
      const sellGasPrice = await provider.getFeeData();
      const adjustedGasPrice = useCustomGas && customGasPrice ? 
        ethers.parseUnits(customGasPrice, 'gwei') : 
        sellGasPrice.gasPrice * 3n;
      
      // 执行卖出交易
      const tx = await router.swapExactTokensForETH(
        amountWei,
        minFunds,
        [tokenAddress, DEFAULT_TOKENS.BNB.address],
        wallet.address,
        Math.floor(Date.now() / 1000) + 60 * 20, // 20分钟截止时间
        {
          gasLimit: 600000,
          gasPrice: adjustedGasPrice
        }
      );
      
      setActiveTx(prev => ({
        ...prev,
        status: '等待交易确认'
      }));
      
      const receipt = await tx.wait();
      
      if (receipt.status === 1) {
        updateTransactionStatus(prev => ({
          ...prev,
          successCount: prev.successCount + 1
        }));
        
        // 获取交易后余额并计算收益
        const afterBnbBalance = await provider.getBalance(wallet.address);
        const receivedBnb = ethers.formatEther(
          BigInt(afterBnbBalance.toString()) - BigInt(beforeBnbBalance.toString())
        );
        
        const txRecord = {
          wallet: wallet.address,
          type: isVolumeTrade ? '做市卖出' : '卖出',
          spentAmount: formattedAmount,
          spentSymbol: tokenInfo.symbol,
          receivedAmount: receivedBnb,
          receivedSymbol: 'BNB',
          txHash: tx.hash,
          explorerUrl: `https://bscscan.com/tx/${tx.hash}`,
          timestamp: new Date().toLocaleString(),
          status: '已完成'
        };
        
        setTxHistory(prev => [txRecord, ...prev]);
        
        // 更新钱包余额
        const updatedWallet = {
          ...wallet,
          bnbBalance: (parseFloat(wallet.bnbBalance) + parseFloat(receivedBnb)).toFixed(6),
          tokenBalance: (parseFloat(wallet.tokenBalance) - parseFloat(formattedAmount)).toFixed(6)
        };
        
        setWallets(prev => prev.map(w => w.address === wallet.address ? updatedWallet : w));
        return true;
      } else {
        throw new Error('交易状态为失败');
      }
    } catch (err) {
      // 交易失败时，重新获取价格并重试
      try {
        console.log(`钱包 ${wallet.address} 卖出交易失败，正在重新获取价格并重试...`);
        await fetchPriceAndLiquidity(); // 重新获取价格信息
        
        // 重新计算交易参数
        const tokenContract = new ethers.Contract(tokenAddress, ERC20_ABI, provider);
        const currentBalance = await tokenContract.balanceOf(wallet.address);
        const percentage = parseFloat(sellPercentage);
        const amountWei = (currentBalance * BigInt(Math.floor(percentage * 100))) / 10000n;
        
        let expectedFunds;
        try {
          expectedFunds = await calculateExpectedSellAmount(amountWei);
        } catch (err) {
          expectedFunds = amountWei * ethers.parseEther("1") / ethers.parseUnits("100000000", tokenInfo.decimals);
        }
        
        const slippagePercent = parseFloat(customSlippage || (isVolumeTrade ? volumeSellSlippage : sellSlippage));
        const minFundsWei = expectedFunds * BigInt(Math.floor((100 - slippagePercent) * 100)) / 10000n;
        const minFunds = minFundsWei > 0n ? minFundsWei : ethers.parseEther("0.0000001");
        
        // 获取新的gas价格
        const gasPrice = await provider.getFeeData();
        const adjustedGasPrice = useCustomGas && customGasPrice ? 
          ethers.parseUnits(customGasPrice, 'gwei') : 
          gasPrice.gasPrice * 3n;
        
        // 重试交易
        const walletSigner = new ethers.Wallet(wallet.privateKey, provider);
        const router = new ethers.Contract(PANCAKE_ROUTER_V2, PANCAKE_ROUTER_ABI, walletSigner);
        
        setActiveTx(prev => ({
          ...prev,
          status: '重试交易'
        }));
        
        // 重新获取交易前余额
        const beforeBnbBalance = await provider.getBalance(wallet.address);
        
        // 重新计算formattedAmount
        const formattedAmount = ethers.formatUnits(amountWei, tokenInfo.decimals);
        
        const retryTx = await router.swapExactTokensForETH(
          amountWei,
          minFunds,
          [tokenAddress, DEFAULT_TOKENS.BNB.address],
          wallet.address,
          Math.floor(Date.now() / 1000) + 60 * 20,
          {
            gasLimit: 600000,
            gasPrice: adjustedGasPrice
          }
        );
        
        const retryReceipt = await retryTx.wait();
        
        if (retryReceipt.status === 1) {
          updateTransactionStatus(prev => ({
            ...prev,
            successCount: prev.successCount + 1
          }));
          
          const afterBnbBalance = await provider.getBalance(wallet.address);
          const receivedBnb = ethers.formatEther(
            BigInt(afterBnbBalance.toString()) - BigInt(beforeBnbBalance.toString())
          );
          
          const txRecord = {
            wallet: wallet.address,
            type: isVolumeTrade ? '做市卖出(重试成功)' : '卖出(重试成功)',
            spentAmount: formattedAmount,
            spentSymbol: tokenInfo.symbol,
            receivedAmount: receivedBnb,
            receivedSymbol: 'BNB',
            txHash: retryTx.hash,
            explorerUrl: `https://bscscan.com/tx/${retryTx.hash}`,
            timestamp: new Date().toLocaleString(),
            status: '已完成'
          };
          
          setTxHistory(prev => [txRecord, ...prev]);
          
          const updatedWallet = {
            ...wallet,
            bnbBalance: (parseFloat(wallet.bnbBalance) + parseFloat(receivedBnb)).toFixed(6),
            tokenBalance: (parseFloat(wallet.tokenBalance) - parseFloat(formattedAmount)).toFixed(6)
          };
          
          setWallets(prev => prev.map(w => w.address === wallet.address ? updatedWallet : w));
          return true;
        } else {
          throw new Error('重试交易失败');
        }
      } catch (retryErr) {
        updateTransactionStatus(prev => ({
          ...prev,
          failCount: prev.failCount + 1,
          lastError: retryErr.message
        }));
        handleError(retryErr, `钱包 ${wallet.address} 卖出交易(重试失败)`);
        return false;
      }
    } finally {
      if (currentIndex === totalCount) {
        resetTransactionStatus();
      }
    }
  };

  // 批量买入
  const batchBuy = async () => {
    if (!provider || !tokenAddress || selectedWallets.length === 0) {
      handleError(new Error("请先连接钱包、输入代币地址并选择钱包"), "批量买入");
      return;
    }

    try {
      setLoading(true);
      setError(null);
      
      const selectedWalletsList = wallets.filter(w => w.isSelected);
      const totalCount = selectedWalletsList.length;
      let successCount = 0;
      let failedWallets = [];
      
      // 预先获取最新价格和流动性信息
      await fetchPriceAndLiquidity();
      
      // 创建所有交易Promise数组
      const transactionPromises = selectedWalletsList.map((wallet, i) => {
        const amount = useRandomBuyAmount ? 
          getRandomAmount(buyAmountRange.min, buyAmountRange.max) : 
          parseFloat(buyAmount);
        
        return processBuyTransaction(
          wallet,
          amount,
          i + 1,
          totalCount,
          false,
          buySlippage
        ).then(success => {
          if (success) {
            successCount++;
          } else {
            failedWallets.push({ wallet, amount });
          }
        });
      });
      
      // 如果选择了顺序执行模式，则按顺序执行交易
      if (buySequentialMode) {
        for (let i = 0; i < transactionPromises.length; i++) {
          await transactionPromises[i];
          if (i < transactionPromises.length - 1) {
            await new Promise(resolve => setTimeout(resolve, buyDelayBetweenTx * 1000));
          }
        }
      } else {
        // 否则，所有交易同时执行
        await Promise.all(transactionPromises);
      }
      
      // 如果有失败的钱包，进行智能重试
      if (failedWallets.length > 0) {
        console.log(`有 ${failedWallets.length} 个钱包买入失败，正在智能重试...`);
        
        // 智能重试：分批重试，每批重试前重新获取价格
        const batchSize = Math.min(10, failedWallets.length); // 每批最多10个钱包
        const batches = [];
        
        for (let i = 0; i < failedWallets.length; i += batchSize) {
          batches.push(failedWallets.slice(i, i + batchSize));
        }
        
        for (let batchIndex = 0; batchIndex < batches.length; batchIndex++) {
          const currentBatch = batches[batchIndex];
          
          // 每批重试前重新获取价格
          await fetchPriceAndLiquidity();
          
          // 重试当前批次的钱包
          const retryPromises = currentBatch.map(({ wallet, amount }, i) => {
            return processBuyTransaction(
              wallet,
              amount,
              i + 1,
              currentBatch.length,
              false,
              buySlippage
            ).then(success => {
              if (success) {
                successCount++;
                // 从失败列表中移除成功的钱包
                failedWallets = failedWallets.filter(fw => fw.wallet.address !== wallet.address);
              }
            });
          });
          
          // 如果选择了顺序执行模式，则按顺序执行重试
          if (buySequentialMode) {
            for (let i = 0; i < retryPromises.length; i++) {
              await retryPromises[i];
              if (i < retryPromises.length - 1) {
                await new Promise(resolve => setTimeout(resolve, buyDelayBetweenTx * 1000));
              }
            }
          } else {
            // 否则，当前批次同时执行
            await Promise.all(retryPromises);
          }
          
          // 批次之间添加延迟，避免网络拥堵
          if (batchIndex < batches.length - 1) {
            await new Promise(resolve => setTimeout(resolve, 2000)); // 5秒延迟
          }
        }
      }
      
      setError(`批量买入完成: ${successCount}/${totalCount} 个钱包成功`);
    } catch (err) {
      handleError(err, "批量买入");
    } finally {
      setLoading(false);
    }
  };

  // 批量卖出
  const batchSell = async () => {
    if (!provider || !tokenAddress || selectedWallets.length === 0) {
      handleError(new Error("请先连接钱包、输入代币地址并选择钱包"), "批量卖出");
      return;
    }

    try {
      setLoading(true);
      setError(null);
      
      const selectedWalletsList = wallets.filter(w => w.isSelected);
      const totalCount = selectedWalletsList.length;
      let successCount = 0;
      let failedWallets = [];
      
      // 预先获取最新价格和流动性信息
      await fetchPriceAndLiquidity();
      
      // 创建所有交易Promise数组
      const transactionPromises = selectedWalletsList.map((wallet, i) => {
        const amount = useRandomSellAmount ? 
          getRandomAmount(sellAmountRange.min, sellAmountRange.max) : 
          parseFloat(sellAmount);
        
        return processSellTransaction(
          wallet,
          amount,
          i + 1,
          totalCount,
          false,
          sellSlippage
        ).then(success => {
          if (success) {
            successCount++;
          } else {
            failedWallets.push({ wallet, amount });
          }
        });
      });
      
      // 如果选择了顺序执行模式，则按顺序执行交易
      if (sellSequentialMode) {
        for (let i = 0; i < transactionPromises.length; i++) {
          await transactionPromises[i];
          if (i < transactionPromises.length - 1) {
            await new Promise(resolve => setTimeout(resolve, sellDelayBetweenTx * 1000));
          }
        }
      } else {
        // 否则，所有交易同时执行
        await Promise.all(transactionPromises);
      }
      
      // 如果有失败的钱包，进行智能重试
      if (failedWallets.length > 0) {
        console.log(`有 ${failedWallets.length} 个钱包卖出失败，正在智能重试...`);
        
        // 智能重试：分批重试，每批重试前重新获取价格
        const batchSize = Math.min(5, failedWallets.length); // 每批最多5个钱包
        const batches = [];
        
        for (let i = 0; i < failedWallets.length; i += batchSize) {
          batches.push(failedWallets.slice(i, i + batchSize));
        }
        
        for (let batchIndex = 0; batchIndex < batches.length; batchIndex++) {
          const currentBatch = batches[batchIndex];
          
          // 每批重试前重新获取价格
          await fetchPriceAndLiquidity();
          
          // 重试当前批次的钱包
          const retryPromises = currentBatch.map(({ wallet, amount }, i) => {
            return processSellTransaction(
              wallet,
              amount,
              i + 1,
              currentBatch.length,
              false,
              sellSlippage
            ).then(success => {
              if (success) {
                successCount++;
                // 从失败列表中移除成功的钱包
                failedWallets = failedWallets.filter(fw => fw.wallet.address !== wallet.address);
              }
            });
          });
          
          // 如果选择了顺序执行模式，则按顺序执行重试
          if (sellSequentialMode) {
            for (let i = 0; i < retryPromises.length; i++) {
              await retryPromises[i];
              if (i < retryPromises.length - 1) {
                await new Promise(resolve => setTimeout(resolve, sellDelayBetweenTx * 1000));
              }
            }
          } else {
            // 否则，当前批次同时执行
            await Promise.all(retryPromises);
          }
          
          // 批次之间添加延迟，避免网络拥堵
          if (batchIndex < batches.length - 1) {
            await new Promise(resolve => setTimeout(resolve, 5000)); // 5秒延迟
          }
        }
      }
      
      setError(`批量卖出完成: ${successCount}/${totalCount} 个钱包成功`);
    } catch (err) {
      handleError(err, "批量卖出");
    } finally {
      setLoading(false);
    }
  };

  // 开始交易
  const startVolumeTrading = async () => {
    if (!provider || !tokenAddress || selectedWallets.length === 0) {
      handleError(new Error("请先连接钱包、输入代币地址并选择钱包"), "开始交易");
      return;
    }

    try {
      setLoading(true);
      setError(null);
      setVolumeTradingActive(true);
      
      const selectedWalletsList = wallets.filter(w => w.isSelected);
      const totalCount = selectedWalletsList.length;
      let successCount = 0;
      let failedWallets = [];
      
      // 预先获取最新价格和流动性信息
      await fetchPriceAndLiquidity();
      
      // 创建所有交易Promise数组
      const transactionPromises = selectedWalletsList.map((wallet, i) => {
        const amount = useRandomVolumeAmount ? 
          getRandomAmount(volumeAmountRange.min, volumeAmountRange.max) : 
          parseFloat(volumeAmount);
        
        return processBuyTransaction(
          wallet,
          amount,
          i + 1,
          totalCount,
          true,
          volumeSlippage
        ).then(success => {
          if (success) {
            successCount++;
          } else {
            failedWallets.push({ wallet, amount, type: 'buy' });
          }
        });
      });
      
      // 如果选择了顺序执行模式，则按顺序执行交易
      if (volumeSequentialMode) {
        for (let i = 0; i < transactionPromises.length; i++) {
          await transactionPromises[i];
          if (i < transactionPromises.length - 1) {
            await new Promise(resolve => setTimeout(resolve, volumeDelayBetweenTx * 1000));
          }
        }
      } else {
        // 否则，所有交易同时执行
        await Promise.all(transactionPromises);
      }
      
      // 如果有失败的钱包，进行智能重试
      if (failedWallets.length > 0) {
        console.log(`有 ${failedWallets.length} 个钱包买入失败，正在智能重试...`);
        
        // 智能重试：分批重试，每批重试前重新获取价格
        const batchSize = Math.min(5, failedWallets.length); // 每批最多5个钱包
        const batches = [];
        
        for (let i = 0; i < failedWallets.length; i += batchSize) {
          batches.push(failedWallets.slice(i, i + batchSize));
        }
        
        for (let batchIndex = 0; batchIndex < batches.length; batchIndex++) {
          const currentBatch = batches[batchIndex];
          
          // 每批重试前重新获取价格
          await fetchPriceAndLiquidity();
          
          // 重试当前批次的钱包
          const retryPromises = currentBatch.map(({ wallet, amount, type }, i) => {
            if (type === 'buy') {
              return processBuyTransaction(
                wallet,
                amount,
                i + 1,
                currentBatch.length,
                true,
                volumeSlippage
              ).then(success => {
                if (success) {
                  successCount++;
                  // 从失败列表中移除成功的钱包
                  failedWallets = failedWallets.filter(fw => fw.wallet.address !== wallet.address);
                }
              });
            } else {
              return processSellTransaction(
                wallet,
                amount,
                i + 1,
                currentBatch.length,
                true,
                volumeSlippage
              ).then(success => {
                if (success) {
                  successCount++;
                  // 从失败列表中移除成功的钱包
                  failedWallets = failedWallets.filter(fw => fw.wallet.address !== wallet.address);
                }
              });
            }
          });
          
          // 如果选择了顺序执行模式，则按顺序执行重试
          if (volumeSequentialMode) {
            for (let i = 0; i < retryPromises.length; i++) {
              await retryPromises[i];
              if (i < retryPromises.length - 1) {
                await new Promise(resolve => setTimeout(resolve, volumeDelayBetweenTx * 1000));
              }
            }
          } else {
            // 否则，当前批次同时执行
            await Promise.all(retryPromises);
          }
          
          // 批次之间添加延迟，避免网络拥堵
          if (batchIndex < batches.length - 1) {
            await new Promise(resolve => setTimeout(resolve, 5000)); // 5秒延迟
          }
        }
      }
      
      // 等待指定的时间间隔
      await new Promise(resolve => setTimeout(resolve, volumeInterval * 1000));
      
      // 重置失败钱包列表
      failedWallets = [];
      
      // 预先获取最新价格和流动性信息
      await fetchPriceAndLiquidity();
      
      // 执行卖出操作
      const sellPromises = selectedWalletsList.map((wallet, i) => {
        const amount = useRandomVolumeAmount ? 
          getRandomAmount(volumeAmountRange.min, volumeAmountRange.max) : 
          parseFloat(volumeAmount);
        
        return processSellTransaction(
          wallet,
          amount,
          i + 1,
          totalCount,
          true,
          volumeSlippage
        ).then(success => {
          if (success) {
            successCount++;
          } else {
            failedWallets.push({ wallet, amount, type: 'sell' });
          }
        });
      });
      
      // 如果选择了顺序执行模式，则按顺序执行交易
      if (volumeSequentialMode) {
        for (let i = 0; i < sellPromises.length; i++) {
          await sellPromises[i];
          if (i < sellPromises.length - 1) {
            await new Promise(resolve => setTimeout(resolve, volumeDelayBetweenTx * 1000));
          }
        }
      } else {
        // 否则，所有交易同时执行
        await Promise.all(sellPromises);
      }
      
      // 如果有失败的钱包，进行智能重试
      if (failedWallets.length > 0) {
        console.log(`有 ${failedWallets.length} 个钱包卖出失败，正在智能重试...`);
        
        // 智能重试：分批重试，每批重试前重新获取价格
        const batchSize = Math.min(5, failedWallets.length); // 每批最多5个钱包
        const batches = [];
        
        for (let i = 0; i < failedWallets.length; i += batchSize) {
          batches.push(failedWallets.slice(i, i + batchSize));
        }
        
        for (let batchIndex = 0; batchIndex < batches.length; batchIndex++) {
          const currentBatch = batches[batchIndex];
          
          // 每批重试前重新获取价格
          await fetchPriceAndLiquidity();
          
          // 重试当前批次的钱包
          const retryPromises = currentBatch.map(({ wallet, amount, type }, i) => {
            if (type === 'buy') {
              return processBuyTransaction(
                wallet,
                amount,
                i + 1,
                currentBatch.length,
                true,
                volumeSlippage
              ).then(success => {
                if (success) {
                  successCount++;
                  // 从失败列表中移除成功的钱包
                  failedWallets = failedWallets.filter(fw => fw.wallet.address !== wallet.address);
                }
              });
            } else {
              return processSellTransaction(
                wallet,
                amount,
                i + 1,
                currentBatch.length,
                true,
                volumeSlippage
              ).then(success => {
                if (success) {
                  successCount++;
                  // 从失败列表中移除成功的钱包
                  failedWallets = failedWallets.filter(fw => fw.wallet.address !== wallet.address);
                }
              });
            }
          });
          
          // 如果选择了顺序执行模式，则按顺序执行重试
          if (volumeSequentialMode) {
            for (let i = 0; i < retryPromises.length; i++) {
              await retryPromises[i];
              if (i < retryPromises.length - 1) {
                await new Promise(resolve => setTimeout(resolve, volumeDelayBetweenTx * 1000));
              }
            }
          } else {
            // 否则，当前批次同时执行
            await Promise.all(retryPromises);
          }
          
          // 批次之间添加延迟，避免网络拥堵
          if (batchIndex < batches.length - 1) {
            await new Promise(resolve => setTimeout(resolve, 5000)); // 5秒延迟
          }
        }
      }
      
      setError(`交易完成: ${successCount}/${totalCount * 2} 个操作成功`);
      
      // 如果交易仍然活跃，则继续下一轮交易
      if (volumeTradingActive) {
        setTimeout(startVolumeTrading, 0);
      }
    } catch (err) {
      handleError(err, "交易");
      setVolumeTradingActive(false);
    } finally {
      setLoading(false);
    }
  };

  // 停止做市交易
  const stopVolumeTrading = () => {
    setIsVolumeTrading(false);
    setVolumeTradeStatus({
      isRunning: false,
      currentRound: 0,
      totalRounds: 1,
      currentAction: '',
      processedCount: 0,
      totalCount: 0
    });
    setError("做市交易已停止");
  };

  // 添加删除钱包函数
  const deleteWallet = (address) => {
    setWallets(prev => prev.filter(w => w.address !== address));
    setSelectedWallets(prev => prev.filter(w => w.address !== address));
  };

  // 渲染UI组件
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
          PancakeSwap V2 批量交易
        </Typography>
        
        {/* 钱包连接和管理 */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            钱包管理
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={connectWallet}
            disabled={loading}
            sx={{ mr: 2 }}
          >
            连接钱包
          </Button>
          {connectedAddress && (
            <Typography variant="body2" color="text.secondary">
              已连接: {connectedAddress}
            </Typography>
          )}
        </Box>

        {/* 管理员登录 */}
        {!adminMode && (
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              管理员登录
            </Typography>
            <TextField
              label="管理员密码"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{ mr: 2 }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleAdminLogin}
              disabled={loading}
            >
              登录
            </Button>
          </Box>
        )}

        {/* 代币信息 */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            代币信息
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={8}>
              <TextField
                label="代币地址"
                value={tokenAddress}
                onChange={(e) => setTokenAddress(e.target.value)}
                fullWidth
                error={!!error && error.includes("代币地址")}
                helperText={error && error.includes("代币地址") ? error : ""}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel>交易对</InputLabel>
                <Select
                  value={selectedPair.symbol}
                  onChange={(e) => {
                    const pair = TRADING_PAIRS.find(p => p.symbol === e.target.value);
                    setSelectedPair(pair);
                    if (tokenAddress) {
                      fetchTokenInfo();
                    }
                  }}
                  label="交易对"
                >
                  {TRADING_PAIRS.map((pair) => (
                    <MenuItem key={pair.symbol} value={pair.symbol}>
                      {pair.symbol}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                onClick={fetchTokenInfo}
                disabled={loading || !tokenAddress}
                startIcon={loading ? <CircularProgress size={20} /> : <RefreshIcon />}
                fullWidth
              >
                {loading ? "获取中..." : "获取代币信息"}
              </Button>
            </Grid>
          </Grid>
          {tokenInfo.name && (
            <Paper sx={{ p: 2, mt: 2 }}>
              <Typography variant="subtitle1" gutterBottom>
                代币详情
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">
                    名称
                  </Typography>
                  <Typography variant="body1">
                    {tokenInfo.name}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">
                    符号
                  </Typography>
                  <Typography variant="body1">
                    {tokenInfo.symbol}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">
                    精度
                  </Typography>
                  <Typography variant="body1" sx={{ 
                    fontFamily: 'monospace', 
                    fontSize: '1.1rem',
                    whiteSpace: 'nowrap',
                    overflow: 'visible'
                  }}>
                    {tokenInfo.decimals}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">
                    合约地址
                  </Typography>
                  <Typography variant="body1" sx={{ wordBreak: 'break-all' }}>
                    {tokenAddress}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          )}
        </Box>

        {/* 价格信息 */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            价格信息
          </Typography>
          <Grid container spacing={2}>
            {/* 添加RPC选择 */}
            <Grid item xs={12}>
              <Paper sx={{ p: 2 }}>
                {/* 添加RPC选择 */}
                <Box sx={{ mb: 2 }}>
                  <FormControl fullWidth>
                    <InputLabel>选择 RPC 节点</InputLabel>
                    <Select
                      value={selectedRpc.url}
                      onChange={(e) => {
                        const rpc = RPC_URLS.find(r => r.url === e.target.value);
                        setSelectedRpc(rpc);
                        setCurrentRpcUrl(rpc.url);
                      }}
                      label="选择 RPC 节点"
                    >
                      {RPC_URLS.map((rpc) => (
                        <MenuItem key={rpc.url} value={rpc.url}>
                          {rpc.url}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>

                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2" color="text.secondary">
                      USDT价格
                    </Typography>
                    <Box sx={{ 
                      width: '100%',
                      maxWidth: 'none',
                      overflow: 'visible',
                      position: 'relative'
                    }}>
                      <Typography 
                        variant="body1" 
                        sx={{ 
                          fontFamily: 'monospace', 
                          fontSize: '1.1rem',
                          whiteSpace: 'nowrap',
                          overflow: 'visible',
                          textOverflow: 'clip',
                          width: 'auto',
                          position: 'absolute',
                          left: 0,
                          right: 'auto',
                          display: 'inline-block'
                        }}
                      >
                        {priceInfo.usdtPrice}
                      </Typography>
                    </Box>
                    <Box sx={{ visibility: 'hidden', height: '2rem' }} />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2" color="text.secondary">
                      {selectedPair.symbol}价格
                    </Typography>
                    <Box sx={{ 
                      width: 'auto',
                      minWidth: '200px',
                      overflow: 'visible',
                      position: 'relative'
                    }}>
                      <Typography variant="body1" component="div" sx={{ 
                        fontFamily: 'monospace', 
                        fontSize: '1.1rem',
                        whiteSpace: 'nowrap',
                        overflow: 'visible',
                        textOverflow: 'unset',
                        width: 'auto',
                        position: 'absolute',
                        left: 0,
                        right: 'auto'
                      }}>
                        {priceInfo.price}
                      </Typography>
                    </Box>
                    <Box sx={{ visibility: 'hidden', height: '2rem' }} />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2" color="text.secondary">
                      流动性 ({selectedPair.symbol})
                    </Typography>
                    <Box sx={{ 
                      width: 'auto',
                      minWidth: '200px',
                      overflow: 'visible'
                    }}>
                      <Typography variant="body1" sx={{ 
                        fontFamily: 'monospace', 
                        fontSize: '1.1rem',
                        whiteSpace: 'nowrap',
                        overflow: 'visible',
                        textOverflow: 'unset',
                        width: 'auto'
                      }}>
                        {priceInfo.liquidity}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
                <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography variant="caption" color="text.secondary">
                    最后更新: {priceInfo.timestamp}
                  </Typography>
                  <IconButton 
                    size="small" 
                    onClick={fetchPriceAndLiquidity}
                    disabled={fetchTokenLoading}
                  >
                    <RefreshIcon />
                  </IconButton>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Box>

        {/* 钱包列表 */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            钱包列表
          </Typography>
          {/* 添加总余额统计显示 */}
          <Paper sx={{ p: 2, mb: 2, bgcolor: 'background.default' }}>
            <Typography variant="subtitle1" gutterBottom>
              总余额统计
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Typography variant="body2" color="text.secondary">
                  总 BNB 余额
                </Typography>
                <Typography variant="h6" sx={{ fontFamily: 'monospace' }}>
                  {totalBalances.bnb} BNB
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="body2" color="text.secondary">
                  总 {tokenInfo.symbol || '代币'} 余额
                </Typography>
                <Typography variant="h6" sx={{ fontFamily: 'monospace' }}>
                  {totalBalances.token} {tokenInfo.symbol || '代币'}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="body2" color="text.secondary">
                  代币总价值 (USDT)
                </Typography>
                <Typography variant="h6" sx={{ fontFamily: 'monospace' }}>
                  {totalBalances.tokenUsdtValue} USDT
                </Typography>
              </Grid>
            </Grid>
          </Paper>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="私钥列表"
                multiline
                rows={4}
                value={privateKeys}
                onChange={(e) => setPrivateKeys(e.target.value)}
                fullWidth
                helperText="每行一个私钥"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button
                variant="contained"
                color="primary"
                onClick={importPrivateKeys}
                disabled={importLoading || !privateKeys.trim()}
                fullWidth
              >
                {importLoading ? "导入中..." : "导入私钥"}
              </Button>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button
                variant="contained"
                color="secondary"
                onClick={checkWalletBalances}
                disabled={updateBalanceLoading || wallets.length === 0}
                fullWidth
              >
                {updateBalanceLoading ? "更新中..." : "更新余额"}
              </Button>
            </Grid>
            
            {/* 添加钱包列表表格 */}
            <Grid item xs={12}>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={wallets.length > 0 && wallets.every(w => w.isSelected)}
                          indeterminate={wallets.some(w => w.isSelected) && !wallets.every(w => w.isSelected)}
                          onChange={(e) => {
                            const newWallets = wallets.map(w => ({
                              ...w,
                              isSelected: e.target.checked
                            }));
                            setWallets(newWallets);
                            setSelectedWallets(e.target.checked ? newWallets : []);
                          }}
                        />
                      </TableCell>
                      <TableCell>钱包地址</TableCell>
                      <TableCell align="right">BNB余额</TableCell>
                      <TableCell align="right">代币余额</TableCell>
                      <TableCell align="right">代币价值(USDT)</TableCell>
                      <TableCell align="center">操作</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {wallets.map((wallet, index) => {
                      const tokenUsdtValue = (parseFloat(wallet.tokenBalance) * parseFloat(priceInfo.usdtPrice)).toFixed(2);
                      return (
                        <TableRow key={index}>
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={wallet.isSelected}
                              onChange={(e) => {
                                const newWallets = [...wallets];
                                newWallets[index] = {
                                  ...wallet,
                                  isSelected: e.target.checked
                                };
                                setWallets(newWallets);
                                setSelectedWallets(newWallets.filter(w => w.isSelected));
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
                              {wallet.address}
                            </Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
                              {wallet.bnbBalance}
                            </Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
                              {wallet.tokenBalance}
                            </Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
                              {tokenUsdtValue}
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => deleteWallet(wallet.address)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </Box>

        {/* 交易设置 */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            交易设置
          </Typography>
          <Grid container spacing={2}>
            {/* 添加GAS设置 */}
            <Grid item xs={12}>
              <Paper sx={{ p: 2, mb: 2 }}>
                <Typography variant="subtitle2" gutterBottom>
                  GAS设置
                </Typography>
                <FormControlLabel
                  control={
                    <Switch
                      checked={useCustomGas}
                      onChange={(e) => setUseCustomGas(e.target.checked)}
                    />
                  }
                  label="使用自定义GAS"
                  sx={{ mb: 2 }}
                />
                {useCustomGas && (
                  <TextField
                    label="GAS价格 (Gwei)"
                    value={customGasPrice}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '' || /^\d*\.?\d*$/.test(value)) {
                        setCustomGasPrice(value);
                      }
                    }}
                    fullWidth
                    sx={{ mb: 2 }}
                    helperText="留空则使用默认GAS价格"
                  />
                )}
              </Paper>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Paper sx={{ p: 2 }}>
                <Typography variant="subtitle2" gutterBottom>
                  买入设置
                </Typography>
                <TextField
                  label="买入数量"
                  value={buyAmount}
                  onChange={(e) => setBuyAmount(e.target.value)}
                  fullWidth
                  sx={{ mb: 2 }}
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={useRandomBuyAmount}
                      onChange={(e) => setUseRandomBuyAmount(e.target.checked)}
                    />
                  }
                  label="随机买入数量"
                  sx={{ mb: 2 }}
                />
                {useRandomBuyAmount && (
                  <Box sx={{ mb: 2 }}>
                    <TextField
                      label="最小数量"
                      value={buyAmountRange.min}
                      onChange={(e) => setBuyAmountRange(prev => ({ ...prev, min: e.target.value }))}
                      sx={{ mr: 2 }}
                    />
                    <TextField
                      label="最大数量"
                      value={buyAmountRange.max}
                      onChange={(e) => setBuyAmountRange(prev => ({ ...prev, max: e.target.value }))}
                    />
                  </Box>
                )}
                <TextField
                  label="滑点 (%)"
                  value={buySlippage}
                  onChange={(e) => setBuySlippage(e.target.value)}
                  fullWidth
                  sx={{ mb: 2 }}
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={buySequentialMode}
                      onChange={(e) => setBuySequentialMode(e.target.checked)}
                    />
                  }
                  label="顺序执行"
                  sx={{ mb: 2 }}
                />
                {buySequentialMode && (
                  <TextField
                    label="交易间隔 (秒)"
                    value={buyDelayBetweenTx}
                    onChange={(e) => setBuyDelayBetweenTx(Number(e.target.value))}
                    fullWidth
                  />
                )}
              </Paper>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Paper sx={{ p: 2 }}>
                <Typography variant="subtitle2" gutterBottom>
                  卖出设置
                </Typography>
                <TextField
                  label="卖出比例 (%)"
                  value={sellAmount}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === '' || (parseFloat(value) >= 0 && parseFloat(value) <= 100)) {
                      setSellAmount(value);
                    }
                  }}
                  fullWidth
                  sx={{ mb: 2 }}
                  helperText="输入0-100之间的数字，表示要卖出的代币百分比"
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={useRandomSellAmount}
                      onChange={(e) => setUseRandomSellAmount(e.target.checked)}
                    />
                  }
                  label="随机卖出比例"
                  sx={{ mb: 2 }}
                />
                {useRandomSellAmount && (
                  <Box sx={{ mb: 2 }}>
                    <TextField
                      label="最小比例 (%)"
                      value={sellAmountRange.min}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === '' || (parseFloat(value) >= 0 && parseFloat(value) <= 100)) {
                          setSellAmountRange(prev => ({ ...prev, min: value }));
                        }
                      }}
                      sx={{ mr: 2 }}
                      helperText="0-100"
                    />
                    <TextField
                      label="最大比例 (%)"
                      value={sellAmountRange.max}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === '' || (parseFloat(value) >= 0 && parseFloat(value) <= 100)) {
                          setSellAmountRange(prev => ({ ...prev, max: value }));
                        }
                      }}
                      helperText="0-100"
                    />
                  </Box>
                )}
                <TextField
                  label="滑点 (%)"
                  value={sellSlippage}
                  onChange={(e) => setSellSlippage(e.target.value)}
                  fullWidth
                  sx={{ mb: 2 }}
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={sellSequentialMode}
                      onChange={(e) => setSellSequentialMode(e.target.checked)}
                    />
                  }
                  label="顺序执行"
                  sx={{ mb: 2 }}
                />
                {sellSequentialMode && (
                  <TextField
                    label="交易间隔 (秒)"
                    value={sellDelayBetweenTx}
                    onChange={(e) => setSellDelayBetweenTx(Number(e.target.value))}
                    fullWidth
                  />
                )}
              </Paper>
            </Grid>
          </Grid>
        </Box>

        {/* 做市交易设置 */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            做市交易设置
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setShowVolumeSettings(!showVolumeSettings)}
            sx={{ mb: 2 }}
          >
            {showVolumeSettings ? '隐藏设置' : '显示设置'}
          </Button>
          
          <Collapse in={showVolumeSettings}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2 }}>
                  <Typography variant="subtitle2" gutterBottom>
                    买入设置
                  </Typography>
                  <TextField
                    label="买入数量"
                    value={volumeBuyAmount}
                    onChange={(e) => setVolumeBuyAmount(e.target.value)}
                    fullWidth
                    sx={{ mb: 2 }}
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        checked={useVolumeRandomBuyAmount}
                        onChange={(e) => setUseVolumeRandomBuyAmount(e.target.checked)}
                      />
                    }
                    label="随机买入数量"
                    sx={{ mb: 2 }}
                  />
                  {useVolumeRandomBuyAmount && (
                    <Box sx={{ mb: 2 }}>
                      <TextField
                        label="最小数量"
                        value={volumeBuyAmountRange.min}
                        onChange={(e) => setVolumeBuyAmountRange(prev => ({ ...prev, min: e.target.value }))}
                        sx={{ mr: 2 }}
                      />
                      <TextField
                        label="最大数量"
                        value={volumeBuyAmountRange.max}
                        onChange={(e) => setVolumeBuyAmountRange(prev => ({ ...prev, max: e.target.value }))}
                      />
                    </Box>
                  )}
                  <TextField
                    label="滑点 (%)"
                    value={volumeBuySlippage}
                    onChange={(e) => setVolumeBuySlippage(e.target.value)}
                    fullWidth
                    sx={{ mb: 2 }}
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        checked={volumeBuySequentialMode}
                        onChange={(e) => setVolumeBuySequentialMode(e.target.checked)}
                      />
                    }
                    label="顺序执行"
                    sx={{ mb: 2 }}
                  />
                  {volumeBuySequentialMode && (
                    <TextField
                      label="交易间隔 (秒)"
                      value={volumeBuyDelayBetweenTx}
                      onChange={(e) => setVolumeBuyDelayBetweenTx(Number(e.target.value))}
                      fullWidth
                    />
                  )}
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2 }}>
                  <Typography variant="subtitle2" gutterBottom>
                    卖出设置
                  </Typography>
                  <TextField
                    label="卖出数量"
                    value={volumeSellAmount}
                    onChange={(e) => setVolumeSellAmount(e.target.value)}
                    fullWidth
                    sx={{ mb: 2 }}
                    helperText="输入要卖出的代币数量"
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        checked={useVolumeRandomSellAmount}
                        onChange={(e) => setUseVolumeRandomSellAmount(e.target.checked)}
                      />
                    }
                    label="随机卖出数量"
                    sx={{ mb: 2 }}
                  />
                  {useVolumeRandomSellAmount && (
                    <Box sx={{ mb: 2 }}>
                      <TextField
                        label="最小数量"
                        value={volumeSellAmountRange.min}
                        onChange={(e) => setVolumeSellAmountRange(prev => ({ ...prev, min: e.target.value }))}
                        sx={{ mr: 2 }}
                      />
                      <TextField
                        label="最大数量"
                        value={volumeSellAmountRange.max}
                        onChange={(e) => setVolumeSellAmountRange(prev => ({ ...prev, max: e.target.value }))}
                      />
                    </Box>
                  )}
                  <TextField
                    label="滑点 (%)"
                    value={volumeSellSlippage}
                    onChange={(e) => setVolumeSellSlippage(e.target.value)}
                    fullWidth
                    sx={{ mb: 2 }}
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        checked={volumeSellSequentialMode}
                        onChange={(e) => setVolumeSellSequentialMode(e.target.checked)}
                      />
                    }
                    label="顺序执行"
                    sx={{ mb: 2 }}
                  />
                  {volumeSellSequentialMode && (
                    <TextField
                      label="交易间隔 (秒)"
                      value={volumeSellDelayBetweenTx}
                      onChange={(e) => setVolumeSellDelayBetweenTx(Number(e.target.value))}
                      fullWidth
                    />
                  )}
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <Paper sx={{ p: 2 }}>
                  <Typography variant="subtitle2" gutterBottom>
                    做市交易参数
                  </Typography>
                  <TextField
                    label="交易轮数"
                    value={volumeRounds}
                    onChange={(e) => setVolumeRounds(Number(e.target.value))}
                    fullWidth
                    sx={{ mb: 2 }}
                  />
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="subtitle2">买入比例</Typography>
                      <Slider
                        value={buyPercentage}
                        onChange={(e, newValue) => setBuyPercentage(newValue)}
                        valueLabelDisplay="auto"
                        step={1}
                        marks
                        min={0}
                        max={100}
                      />
                      <Typography variant="body2" align="center">
                        {buyPercentage}%
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="subtitle2">卖出比例</Typography>
                      <Slider
                        value={sellPercentage}
                        onChange={(e, newValue) => setSellPercentage(newValue)}
                        valueLabelDisplay="auto"
                        step={1}
                        marks
                        min={0}
                        max={100}
                      />
                      <Typography variant="body2" align="center">
                        {sellPercentage}%
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          </Collapse>
        </Box>

        {/* 交易操作 */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            交易操作
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={batchBuy}
            disabled={loading || selectedWallets.length === 0}
            sx={{ mr: 2 }}
          >
            批量买入
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={batchSell}
            disabled={loading || selectedWallets.length === 0}
            sx={{ mr: 2 }}
          >
            批量卖出
          </Button>
          <Button
            variant="contained"
            color="success"
            onClick={startVolumeTrading}
            disabled={loading || selectedWallets.length === 0 || isVolumeTrading}
            sx={{ mr: 2 }}
          >
            开始做市
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={stopVolumeTrading}
            disabled={loading || !isVolumeTrading}
          >
            停止做市
          </Button>
        </Box>

        {/* 交易状态 */}
        {activeTx && (
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              当前交易
            </Typography>
            <Paper sx={{ p: 2 }}>
              <Typography variant="body2">
                钱包: {activeTx.wallet}
              </Typography>
              <Typography variant="body2">
                类型: {activeTx.type}
              </Typography>
              <Typography variant="body2">
                数量: {activeTx.amount}
              </Typography>
              <Typography variant="body2">
                状态: {activeTx.status}
              </Typography>
              <Typography variant="body2">
                进度: {activeTx.index}/{activeTx.total}
              </Typography>
            </Paper>
          </Box>
        )}

        {/* 做市交易状态 */}
        {isVolumeTrading && (
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              做市交易状态
            </Typography>
            <Paper sx={{ p: 2 }}>
              <Typography variant="body2">
                当前轮数: {volumeTradeStatus.currentRound}/{volumeTradeStatus.totalRounds}
              </Typography>
              <Typography variant="body2">
                当前操作: {volumeTradeStatus.currentAction}
              </Typography>
              <Typography variant="body2">
                进度: {volumeTradeStatus.processedCount}/{volumeTradeStatus.totalCount}
              </Typography>
            </Paper>
          </Box>
        )}

        {/* 交易历史 */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            交易历史
          </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>时间</TableCell>
                  <TableCell>钱包</TableCell>
                  <TableCell>类型</TableCell>
                  <TableCell>支付</TableCell>
                  <TableCell>接收</TableCell>
                  <TableCell>状态</TableCell>
                  <TableCell>操作</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {txHistory.map((tx, index) => (
                  <TableRow key={index}>
                    <TableCell>{tx.timestamp}</TableCell>
                    <TableCell>{tx.wallet}</TableCell>
                    <TableCell>{tx.type}</TableCell>
                    <TableCell>
                      {tx.spentAmount} {tx.spentSymbol}
                    </TableCell>
                    <TableCell>
                      {tx.receivedAmount} {tx.receivedSymbol}
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={tx.status}
                        color={tx.status === '已完成' ? 'success' : tx.status === '失败' ? 'error' : 'default'}
                      />
                    </TableCell>
                    <TableCell>
                      {tx.explorerUrl && (
                        <Button
                          variant="outlined"
                          size="small"
                          href={tx.explorerUrl}
                          target="_blank"
                        >
                          查看
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        {/* 交易状态显示 */}
        {transactionStatus.isProcessing && (
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              交易状态
            </Typography>
            <Paper sx={{ p: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="subtitle2">
                    当前操作: {transactionStatus.currentOperation}
                  </Typography>
                  <LinearProgress 
                    variant="determinate" 
                    value={(transactionStatus.progress / transactionStatus.total) * 100}
                    sx={{ mt: 1 }}
                  />
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    进度: {transactionStatus.progress}/{transactionStatus.total}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="success.main">
                    成功: {transactionStatus.successCount}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="error.main">
                    失败: {transactionStatus.failCount}
                  </Typography>
                </Grid>
                {transactionStatus.lastError && (
                  <Grid item xs={12}>
                    <Typography variant="body2" color="error">
                      最后错误: {transactionStatus.lastError}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </Paper>
          </Box>
        )}

        {/* 错误提示 */}
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {/* 加载状态 */}
        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            <CircularProgress />
          </Box>
        )}

        {/* 确认对话框 */}
        <Dialog
          open={showConfirmDialog}
          onClose={() => setShowConfirmDialog(false)}
        >
          <DialogTitle>确认操作</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {pendingAction?.type === 'rebalance' && (
                <>
                  您确定要重新分配钱包余额吗？
                  <br />
                  这将从余额充足的钱包转入资金到余额不足的钱包。
                </>
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowConfirmDialog(false)}>取消</Button>
            <Button
              onClick={() => {
                if (pendingAction?.type === 'rebalance') {
                  // 执行余额重新分配
                  const { sufficientWallets, insufficientWallets, MIN_BNB_BALANCE, TARGET_BNB_BALANCE } = pendingAction;
                  // ... 实现余额重新分配逻辑
                }
                setShowConfirmDialog(false);
              }}
              color="primary"
            >
              确认
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </Container>
  );
}

export default PancakeV2BatchSwap;